import { AccountShip } from './AccountShip';
import { connect } from 'react-redux';
import { addressesActions } from 'src/store/modules/addresses';
import { userDataSel } from 'src/store/modules/user';
import {
  addressesSel,
  addressesIsPendingSel,
  addressesErrorSel
} from 'src/store/modules/addresses';
import {
  accountViewActions,
  accountAddressRequestSel
} from 'src/store/modules/accountview';
import ShipAddressModel from 'src/model/shipAddress.model';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    addresses: addressesSel(state),
    loading: addressesIsPendingSel(state),
    error: addressesErrorSel(state).hasFailed,
    userData: userDataSel(state),
    addressRequest: accountAddressRequestSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  loadAddresses: () => dispatch(addressesActions.getAddresses()),
  onSearchTextChange: (text: string) => console.log(text), // dispatch(accountViewActions.setMenuOption(selected)),
  onSearch: () => console.log('search'),
  onAddAddress: (params: ShipAddressModel) =>
    dispatch(accountViewActions.shipAddRequest(params)),
  onChangeAddress: (params: ShipAddressModel) =>
    dispatch(accountViewActions.shipChangeRequest(params)),
  onRemoveAddress: (params: { addressId: number; customerNumber: number }) =>
    dispatch(accountViewActions.shipRemovalRequest(params)),
  onSetAddress: (params?: ShipAddressModel) =>
    dispatch(accountViewActions.setShipRequestAddress(params)),
  onClearAddressValidation: () =>
    dispatch(accountViewActions.setShipAddressValidation())
});

export const pureComponent = AccountShip;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(AccountShip));

interface IDispatchFromProps {
  loadAddresses(): void;
  onSearchTextChange(text: string): void;
  onSearch(): void;
  onAddAddress(params: ShipAddressModel): void;
  onChangeAddress(params: ShipAddressModel): void;
  onRemoveAddress(params: { addressId: number; customerNumber: number }): void;
  onSetAddress(params?: ShipAddressModel): void;
  onClearAddressValidation(): void;
}
